import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import { useMedia } from 'react-use';
import useUser from '@/hooks/useUser';
import ShoppingCarouselListItem from '@/components/shoppings/ShoppingCarouselListItem';
import { useUiStatus } from '@/hooks/useUiStatus';
import { favoritePost } from '@/domains/firestore/user';
import { IShopping } from '@/@types/generated/contentful';

type ComponentProps = {
  shopping: IShopping;
};

const ShoppingCarouselListItemContainer: React.FC<ComponentProps> = ({ shopping }) => {
  const [isLoading, setLoading] = useState(false);
  const { setModalState } = useUiStatus();
  const dispatch = useDispatch();
  const isSp = useMedia('(max-width: 640px)');
  const user = useUser();
  const isFavorite = !!user?.favorited?.includes(shopping.fields.id);
  const handleRequestUpdateFavorite = useCallback(
    async (postId: string) => {
      if (!user) {
        setModalState(true);
      } else {
        setLoading(true);
        await favoritePost({ userId: user.uid, postId });
        await dispatch(updateUser(user.uid));
        setLoading(false);
      }
    },
    [dispatch, setModalState, user]
  );
  return (
    <ShoppingCarouselListItem
      shopping={shopping}
      onRequestUpdateFavorite={handleRequestUpdateFavorite}
      isFavorite={isFavorite}
      isSp={isSp}
      invalid={isLoading}
    />
  );
};

export default ShoppingCarouselListItemContainer;
